<template>
  <div class="memberIndex">
    <div class="left" :style="height">
      <div class="logined_wrap">
        <div class="title clear">
          <span>{{ loginInfos.companyName }}</span>
          <span v-if="Certify"><img src="@/assets/img/icon_notcertified.png" /></span>
          <span v-if="!Certify"><img src="@/assets/img/icon_certified.png" /></span>
        </div>
        <ul class="list">
          <li>
            <img src="@/assets/img/icon_contacts.png" />
            <span>
              <label class="labell">联系人：</label>
              {{ loginInfos.name }}({{ loginInfos.tel }})
            </span>
          </li>
          <li>
            <img src="@/assets/img/icon_effectivedate.png" />
            <span>
              <label class="labell">有效日期：</label>
              {{ loginInfos.date }}
            </span>
          </li>
        </ul>
      </div>
      <el-menu :default-active="activeIndex" class="el_menu1" mode="vertical" @select="handleSelect" :router="true">
        <el-menu-item index="/MemberCenter">首页</el-menu-item>
        <el-menu-item index="/MemberCenter">招标中心</el-menu-item>
        <!-- <el-submenu index="mcBidding"">
        <template slot="title">招标中心</template>
        <el-menu-item index="/" >选项一</el-menu-item>
        <el-menu-item index="/">选项二</el-menu-item>
        <el-menu-item index="/">选项三</el-menu-item>
        <el-menu-item index="/">选项四</el-menu-item>
      </el-submenu> -->
        <el-menu-item index="/MemberCenter">在线报价</el-menu-item>
        <el-menu-item index="/MemberCenter">在线竞价</el-menu-item>
        <el-menu-item index="/MemberCenter">采购合同</el-menu-item>
        <el-menu-item index="/MemberCenter">采购订单</el-menu-item>
        <el-menu-item index="/MemberCenter">供货目录</el-menu-item>
        <el-submenu index="/MemberCenter">
          <template slot="title"> 企业信息 </template>
          <el-menu-item index="/EnterpriseInform">查看企业信息</el-menu-item>
          <el-menu-item index="/ChangeInform">修改企业信息</el-menu-item>
          <el-menu-item index="/AccountDataEdit">修改账号信息</el-menu-item>
          <el-menu-item index="/ContactsChange">修改联系人</el-menu-item>
          <el-menu-item index="/AuditRecord">查看审核记录</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="right">在线报价</div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      height: {
        height: ''
      },
      activeIndex: '',
      flexData: [
        { num: '1', title: '今日报价' },
        { num: '2', title: '整改通知' }
      ],
      Certify: true,
      aboutTab: '1',
      activeName: 'default',
      projectName: 'defaultPJ',
      loginInfos: {
        companyName: '广州天天开心有限公司',
        name: '张晓丽',
        tel: '13800138000',
        date: '2020-06-23'
      },
      biddlist1: [
        { type: '邀请招标', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' },
        { type: '招标', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' },
        { type: '单一来源', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' },
        { type: '邀请招标', title: '关于“广电计量直流低电阻校准装置采购项目”中标的公告', date: '2020-04-21 11:14' }
      ],
      tableData: [
        {
          name: '2020年频率计采购项目（第二次）”询价公告',
          publishDate: '2020-05-15 11:18',
          endDate: '2020-05-15 11:18'
        },
        {
          name: '2020年频率计采购项目（第二次）”询价公告',
          publishDate: '2020-05-15 11:18',
          endDate: '2020-05-15 11:18'
        },
        {
          name: '2020年频率计采购项目（第二次）”询价公告',
          publishDate: '2020-05-15 11:18',
          endDate: '2020-05-15 11:18'
        },
        {
          name: '2020年频率计采购项目（第二次）”询价公告',
          publishDate: '2020-05-15 11:18',
          endDate: '2020-05-15 11:18'
        }
      ]
    }
  },
  created() {
    this.heightCom()
  },
  computed: {},
  methods: {
    heightCom() {
      this.height.height = window.innerHeight - 60 + 'px'
    },
    goDetail() {
      this.$router.push('/Notify')
    },
    handleNotify(val) {
      console.log(val)
    },
    handleProject(val) {
      console.log(val)
    },
    handleSelect(val) {
      console.log(val)
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;
  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;
    .logined_wrap {
      padding: 10px;
      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }
      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }
      .btn_1 {
        width: 100%;
      }
      .img {
        margin-left: 30px;
      }
      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;
          .labell {
            font-weight: bold;
          }
          img {
            margin-right: 5px;
          }
        }
      }
    }
  }
  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 10px 10px 10px;
    .welcome {
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
